function escapeRegExp(s) {
  return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

/** Longer phrases first so regex alternation prefers them (e.g. "API gateway" before "API"). */
export function keywordsSortedForMatch(keywords) {
  const list = keywords.map((k) => String(k).trim()).filter(Boolean);
  return [...list].sort((a, b) => b.length - a.length);
}

/**
 * Split text into plain / keyword-hit segments for rendering (bold matches).
 * @param {string} text
 * @param {string[]} keywords
 * @returns {{ text: string, hit: boolean }[]}
 */
export function segmentTextByKeywords(text, keywords) {
  if (text == null || text === "") return [];
  const list = keywordsSortedForMatch(keywords);
  if (!list.length) return [{ text: String(text), hit: false }];
  let re;
  try {
    re = new RegExp(`(${list.map(escapeRegExp).join("|")})`, "gi");
  } catch {
    return [{ text: String(text), hit: false }];
  }
  const parts = String(text).split(re);
  const lower = new Set(list.map((k) => k.toLowerCase()));
  const out = [];
  for (const p of parts) {
    if (p === "") continue;
    out.push({ text: p, hit: lower.has(p.toLowerCase()) });
  }
  return out.length ? out : [{ text: String(text), hit: false }];
}
